import { MediaListenerProps } from '@xingternal/util';

import { VisibleJob } from '@/graphql/generated';

interface HasSidebarJobsProps {
  job: VisibleJob;
  matchedMedia: MediaListenerProps;
}

const HTML_DESCRIPTION = 'HtmlDescription';

const isDesktop = (matchedMedia) => matchedMedia === 'desktop' || matchedMedia === 'nav';
const doesJobAcceptSimilarJobsSidebar = (job) => !job.prioritized && job.description.__typename === HTML_DESCRIPTION;

export const hasSidebarJobs = ({ job, matchedMedia }: HasSidebarJobsProps) =>
  isDesktop(matchedMedia) && doesJobAcceptSimilarJobsSidebar(job);
